import { gql } from 'react-apollo';

export const getChurches = gql`
  query getChurches {
    churches {
      id
      code
      name
      timezone
      revival {
        id
        phase
        title
        image {
          default
        }
        preparationStartDate: preparation_start_date
        startDate: start_date
        endDate: end_date
      }
      address: address_line_1
      contactPerson: contact_person
      evangelist {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churches/queries/getChurches.js